module.exports = __webpack_public_path__ + "static/media/CNH.180a069b.svg";